import React, { Component } from 'react';

export class CustomerTransactionList extends Component {
    render() {
        return <div>Transaction list</div>;
    }
}

export default CustomerTransactionList;



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerTransactionList.jsx